/*  Blue Bathware package builder  v4.4  (22 Oct 2026)
    --------------------------------------------------------------------------
    Used by sections/bb-package-builder.liquid. No dependencies, no theme files edited.

    What it does
      - Reads the package from the section (built from the product's package slots in
        Shopify admin, or the older custom.package_config JSON).
      - Sits inside the product column, straight above the theme's quantity and Add to
        cart, as a compact list. Each item can be changed or removed, but never below
        the package minimum (6 items by default).
      - Keeps the theme's price at the top of the page in step with the chosen set.
      - Add to cart (the theme's own button):
          unchanged set   -> the package product itself, one cart line, contents listed
                             under it as line item properties.
          changed set     -> each chosen product as its own cart line, tagged with the
                             package name. The price comes from the store's automatic
                             discount, which this script only predicts for display.
      - If anything it needs is missing it removes itself and the standard product form
        carries on selling the package product as normal.

    v4.4
      - Items with no package discount (tier set to 0% in the section settings: the Zenmo vanities,
        mirror cabinets and baths) show their everyday price on an unchanged package too, so the
        lines add up to the package price.

    v4.3
      - "See specs" shows the photos for the finish being looked at: its own photo, its other
        angles, room shots in that finish, then the dimension drawings (never cut off). It
        reads the product's image map (custom.bb_media) through the specs view; without the
        map it still keeps the drawings and leaves out photos named after other finishes.

    v4.2
      - The theme's one-value Colour picker is hidden on package pages (it was counted twice
        before: the swatch and its radio button).

    v4.1
      - When a choice forces another item to change (a hand shower added to a rain shower
        needs the diverter mixer), the replacement keeps the same plate shape where it can.
      - More showers than shower mixers (quantity or "Add another"): the shower line asks
        whether to add a mixer for each extra shower.

    v3
      - "Pick one" options: an option can list several variants of one product (vanity sizes and
        tops, toilet inlet, mirror cabinet size and colour). The customer picks one with chips.
      - Sizes follow each other: picking a size on one item moves the other picked items
        (vanity and mirror cabinet) to the same size where they come in it.
      - "Automatic" slots fill themselves when one of their options becomes allowed
        (a stone top brings a basin) and empty when none is.
      - Each item can carry its own cart discount tier (product tag pkg-items-10 / -5 / -0),
        so a package can mix brands that are already discounted with ones that aren't.

    v4
      - Quantity on every line (1 to 5) and "Add another": a second product from the same line
        (both a basin mixer and a tower mixer). Not offered on the vanity, toilet, mirror or bath.
      - Double-bowl vanities offer to add the second basin mixer and waste (and basin).
      - Change opens a panel (a bottom sheet on phones) with thumbnails; each product has a
        "See specs" popup (photos with tap to zoom, specifications and warranty) instead of a link.
      - The phone bar, the panel and the popup sit in their own layer on the page body, so the
        theme's layout can't clip them.
*/
(function () {
  'use strict';
  if (window.BBPKG && window.BBPKG.loaded) return;

  var BBPKG = (window.BBPKG = { loaded: true, version: '4.4', instances: [] });

  /* ------------------------------------------------------------ helpers */
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Product titles as shown in the builder and on order lines: no hidden characters, no lead-free wording */
  function cleanTitle(v) {
    return String(v == null ? '' : v)
      .replace(/[\u0000-\u001f\u007f-\u009f]/g, '')
      .replace(/\s*[-\u2013]\s*LF\b/g, '')
      .replace(/\s*[-\u2013]?\s*\(?\blead[- ]free\b\)?/gi, '')
      .replace(/^(\w+) \1\b/i, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }
  function money(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var neg = cents < 0;
    cents = Math.abs(cents);
    function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var whole = Math.floor(cents / 100);
    var dec = ('0' + (cents % 100)).slice(-2);
    var fmt = format || '${{amount}}';
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return group(Math.round(cents / 100), ',');
        case 'amount_with_comma_separator': return group(whole, '.') + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(cents / 100), '.');
        default: return group(whole, ',') + '.' + dec;
      }
    });
    out = out.replace(/<[^>]*>/g, '');
    return (neg ? '-' : '') + out;
  }

  function imgUrl(src, width) {
    if (!src) return '';
    var s = String(src);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    s = s.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function rootPath() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function readJSON(host, selector) {
    var el = host.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function uid() {
    return 'p' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  function num(v) { var m = String(v == null ? '' : v).match(/\d+/); return m ? m[0] : null; }
  function isSize(name) { return /size|width/i.test(String(name || '')); }
  /* the variant's own option values by option name, e.g. { Size: '900 mm', Top: 'Ceramic Top' } */
  function dimsOf(it) {
    var o = {}, names = it.option_names || [], vals = it.options || [];
    names.forEach(function (n, i) { if (vals[i] != null && vals[i] !== 'Default Title') o[n] = String(vals[i]); });
    return o;
  }

  function fill(str, map) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  /* ------------------------------------------------------------ builder */
  function Builder(host) {
    this.host = host;
    this.cfg = readJSON(host, '[data-bbpkg-config]');
    this.pkg = readJSON(host, '[data-bbpkg-product]') || {};
    this.txt = readJSON(host, '[data-bbpkg-text]') || {};
    this.moneyFormat = this.pkg.money_format || '${{amount}}';
    this.position = host.getAttribute('data-position') || 'inline';
    this.collapseAfter = parseInt(host.getAttribute('data-collapse') || '5', 10) || 0;
    this.catalogue = {};          // handle -> product json (only for items without inline data)
    this.sel = {};                // slot id -> option id | null
    this.adjusted = {};           // slot id -> true when we changed it to keep the set valid
    this.userOff = {};            // automatic slot id -> true when the customer removed it
    this.openTray = null;
    this.qty = {};                // slot id -> quantity of its line (1 when missing)
    this.extras = [];             // added lines: { key, slot, opt, q, vsel }
    this.doubleSeen = {};         // double-bowl prompts answered, by vanity variant id
    this.mixerSeen = {};          // second-shower prompts answered, by 'showers:mixers'
    this.sheet = null;            // { mode: 'swap' | 'add' | 'extra', slot, key }
    this.specs = null;            // the product shown in the specs popup
    this.zoom = null;             // image shown full screen
    this.specCache = {};
    this.expanded = false;
    this.busy = false;
    this.error = '';
    this.ready = false;
  }

  Builder.prototype.fail = function (why) {
    if (window.console && console.warn) console.warn('[bb-package] builder switched off: ' + why);
    this.host.setAttribute('hidden', '');
    this.host.setAttribute('data-bbpkg-off', why);
    if (this.inlineEl && this.inlineEl.parentNode) this.inlineEl.parentNode.removeChild(this.inlineEl);
    if (this.layerHost && this.layerHost.parentNode) this.layerHost.parentNode.removeChild(this.layerHost);
    document.documentElement.style.overflow = '';
    this.restorePrice();
    this.unhookForm();
  };

  /* older JSON uses "required"; the admin version uses "removable" */
  Builder.prototype.normalise = function () {
    this.cfg.slots.forEach(function (s) {
      if (s.removable == null) s.removable = !s.required;
      s.removable = !!s.removable;
      if (s.default === '' || s.default === undefined) s.default = null;
      s.auto = !!s.auto;
      s.options = (s.options || []).filter(function (o) { return o && o.items && o.items.length; });
      s.options.forEach(function (o) { o.pick = !!o.pick && o.items.length > 1; o.vsel = 0; o.vdef = 0; });
    });
    this.cfg.slots = this.cfg.slots.filter(function (s) { return s.options.length; });
  };

  Builder.prototype.start = function () {
    var self = this, cfg = this.cfg;
    if (!cfg || !cfg.slots || !cfg.slots.length) return this.fail('no package data');
    this.normalise();
    if (!this.cfg.slots.length) return this.fail('no items');
    var handles = {};
    cfg.slots.forEach(function (s) {
      s.options.forEach(function (o) {
        o.items.forEach(function (it) { if (it.handle && !self.hasInline(it)) handles[it.handle] = true; });
      });
    });
    var list = Object.keys(handles);
    var base = rootPath();
    return Promise.all(list.map(function (h) {
      return getJSON(base + 'products/' + encodeURIComponent(h) + '.js')
        .then(function (p) { self.catalogue[h] = p; })
        .catch(function () { self.catalogue[h] = null; });
    })).then(function () {
      self.resolve();
      if (!self.defaultsOk()) return self.fail('a default item is missing or unavailable');
      self.cfg.slots.forEach(function (s) { self.sel[s.id] = s.default; });
      self.floor = Math.min(self.rule().min || 0, self.count(self.items()));
      self.mount();
      self.ready = true;
      self.render();
      self.hookForm();
      self.host.removeAttribute('data-bbpkg-loading');
      self.host.dispatchEvent(new CustomEvent('bbpkg:ready', { bubbles: true }));
    });
  };

  Builder.prototype.hasInline = function (it) {
    return it.variant_id != null && it.price != null;
  };

  /* match every configured item to a live variant */
  Builder.prototype.resolve = function () {
    var self = this;
    this.cfg.slots.forEach(function (slot) {
      slot.options.forEach(function (opt) {
        opt._ok = true;
        opt._price = 0; opt._rrp = 0;
        opt.items.forEach(function (it) {
          var v = null, p = null;
          if (self.hasInline(it)) {
            v = { id: it.variant_id, sku: it.sku || '', price: Number(it.price) || 0,
              compare_at_price: Number(it.compare_at_price) || 0, available: it.available !== false };
            it._img = it.image || '';
            it._url = it.url || (rootPath() + 'products/' + it.handle);
          } else {
            p = self.catalogue[it.handle];
            if (p && p.variants) {
              var want = String(it.sku || '').trim().toLowerCase();
              for (var i = 0; i < p.variants.length; i++) {
                if (want && String(p.variants[i].sku || '').trim().toLowerCase() === want) { v = p.variants[i]; break; }
              }
              if (!v && !want && p.variants.length === 1) v = p.variants[0];
            }
            if (v) {
              it._img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
              it._url = (p.url || (rootPath() + 'products/' + p.handle)) + (p.variants.length > 1 ? '?variant=' + v.id : '');
            }
          }
          it._v = v;
          it._dims = dimsOf(it);
          it._vt = Object.keys(it._dims).map(function (k) { return it._dims[k]; }).join(' / ');
          it._ok = !!(v && v.available);
          if (!it._ok) { if (!opt.pick) opt._ok = false; return; }
          it._price = v.price;
          it._rrp = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
          it._title = cleanTitle(it.name || (p && p.title) || it.handle);
          opt._price += it._price; opt._rrp += it._rrp;
        });
        if (opt.pick) {
          var first = -1;
          opt.items.forEach(function (it, i) { if (it._ok && first === -1) first = i; });
          opt._ok = first !== -1;
          opt.vdef = opt.vsel = Math.max(0, first);
        }
      });
    });
  };

  /* the items an option puts in the package: all of them, or the picked variant */
  Builder.prototype.optItems = function (opt, vsel) {
    if (!opt.pick) return opt.items;
    var i = vsel == null ? opt.vsel : vsel;
    return [opt.items[i] || opt.items[0]];
  };

  Builder.prototype.defaultsOk = function () {
    return this.cfg.slots.every(function (s) {
      if (s.default == null) return true;
      var o = s.options.filter(function (x) { return x.id === s.default; })[0];
      return !!(o && o._ok);
    });
  };

  /* ------------------------------------------------------------ state */
  Builder.prototype.slot = function (id) {
    return this.cfg.slots.filter(function (s) { return s.id === id; })[0];
  };
  Builder.prototype.option = function (slot, id) {
    return slot.options.filter(function (o) { return o.id === id; })[0] || null;
  };
  Builder.prototype.chosenIds = function (sel, exceptSlot) {
    var out = [];
    for (var k in sel) if (Object.prototype.hasOwnProperty.call(sel, k) && k !== exceptSlot && sel[k] != null) out.push(sel[k]);
    return out;
  };
  /* an option can be limited to sets that include (only_with) or exclude (not_with)
     certain other options; the older JSON uses "when": { slot: [option ids or null] } */
  Builder.prototype.allowed = function (opt, sel, ownSlot) {
    sel = sel || this.sel;
    if (!opt._ok) return false;
    var chosen = this.chosenIds(sel, ownSlot);
    if (opt.only_with && opt.only_with.length) {
      var hit = opt.only_with.some(function (id) { return chosen.indexOf(id) !== -1; });
      if (!hit) return false;
    }
    if (opt.not_with && opt.not_with.length) {
      var clash = opt.not_with.some(function (id) { return chosen.indexOf(id) !== -1; });
      if (clash) return false;
    }
    if (opt.when) {
      for (var k in opt.when) {
        if (Object.prototype.hasOwnProperty.call(opt.when, k)) {
          var have = sel[k] == null ? null : sel[k];
          if (opt.when[k].indexOf(have) === -1) return false;
        }
      }
    }
    return true;
  };
  Builder.prototype.choices = function (slot, sel) {
    var self = this;
    return slot.options.filter(function (o) { return self.allowed(o, sel, slot.id); });
  };

  /* keep every slot valid after a change */
  Builder.prototype.settle = function (changedId, sel, adjusted, off) {
    var self = this;
    sel = sel || this.sel;
    adjusted = adjusted || this.adjusted;
    off = off || this.userOff || {};
    for (var pass = 0; pass < 5; pass++) {
      var moved = false;
      this.cfg.slots.forEach(function (slot) {
        var cur = sel[slot.id];
        if (cur == null) return;
        var opt = self.option(slot, cur);
        if (opt && self.allowed(opt, sel, slot.id)) return;
        var ok = self.choices(slot, sel);
        var def = ok.filter(function (o) { return o.id === slot.default; })[0];
        var shape = shapeOf(opt), same = shape ? ok.filter(function (o) { return shapeOf(o) === shape; }) : [];
        var next = (same.length ? (same.filter(function (o) { return o === def; })[0] || same[0]) : null) || def || ok[0] || null;
        sel[slot.id] = next ? next.id : null;
        if (slot.id !== changedId) adjusted[slot.id] = true;
        moved = true;
      });
      if (!moved) break;
    }
    /* automatic slots fill themselves once one of their options is allowed */
    this.cfg.slots.forEach(function (slot) {
      if (!slot.auto) return;
      /* nothing allowed (ceramic top): forget a removal, so the next stone top brings the basin back */
      if (!self.choices(slot, sel).length) { delete off[slot.id]; return; }
      if (sel[slot.id] != null || off[slot.id]) return;
      var back = self.backOption(slot, sel);
      if (back) { sel[slot.id] = back.id; if (slot.id !== changedId) adjusted[slot.id] = true; }
    });
    return sel;
  };

  Builder.prototype.preview = function (slotId, optId) {
    var sel = {}, k;
    for (k in this.sel) if (Object.prototype.hasOwnProperty.call(this.sel, k)) sel[k] = this.sel[k];
    sel[slotId] = optId;
    var off = {};
    for (k in this.userOff) if (Object.prototype.hasOwnProperty.call(this.userOff, k) && k !== slotId) off[k] = true;
    if (optId == null && this.slot(slotId) && this.slot(slotId).auto) off[slotId] = true;
    return this.settle(slotId, sel, {}, off);
  };

  Builder.prototype.keepsFloor = function (sel) {
    return this.count(this.items(sel)) >= (this.floor || 0);
  };

  Builder.prototype.canRemove = function (slot) {
    if (!slot.removable || this.sel[slot.id] == null) return false;
    return this.keepsFloor(this.preview(slot.id, null));
  };

  Builder.prototype.canChoose = function (slot, opt) {
    if (!this.allowed(opt, this.sel, slot.id)) return false;
    return this.keepsFloor(this.preview(slot.id, opt.id));
  };

  Builder.prototype.choose = function (slotId, optId) {
    var slot = this.slot(slotId);
    if (!slot) return;
    var opt = this.option(slot, optId);
    if (!opt || !this.canChoose(slot, opt)) return;
    this.adjusted = {};
    delete this.userOff[slotId];   // choosing it again undoes the customer's removal; other removals stand
    var was = this.sel[slotId] == null ? null : this.option(slot, this.sel[slotId]);
    this.sel[slotId] = optId;
    this.matchSize(slotId, opt, was);
    this.settle(slotId);
    this.error = ''; this.done = false;
    if (this.openTray === slotId) { this.openTray = null; this.focusKey = 'tray-' + slotId; }
    this.render();
  };
  Builder.prototype.remove = function (slotId) {
    var slot = this.slot(slotId);
    if (!slot || !this.canRemove(slot)) return;
    this.adjusted = {};
    if (slot.auto) this.userOff[slotId] = true;
    this.sel[slotId] = null;
    delete this.qty[slotId];
    if (this.openTray === slotId) this.openTray = null;
    this.settle(slotId);
    this.error = ''; this.done = false;
    this.render();
  };
  Builder.prototype.restore = function (slotId) {
    var slot = this.slot(slotId);
    if (!slot) return;
    var pick = this.backOption(slot);
    if (!pick) return;
    this.choose(slotId, pick.id);
  };
  Builder.prototype.reset = function () {
    var self = this;
    this.cfg.slots.forEach(function (s) {
      self.sel[s.id] = s.default;
      s.options.forEach(function (o) { if (o.pick) o.vsel = o.vdef; });
    });
    this.adjusted = {}; this.userOff = {}; this.openTray = null; this.error = ''; this.done = false;
    this.qty = {}; this.extras = []; this.doubleSeen = {}; this.mixerSeen = {};
    this.render();
  };

  /* ------------------------------------------------------------ pick one variant */
  /* option names whose values differ between the usable variants, values in order (sizes by number) */
  Builder.prototype.dims = function (opt) {
    var names = [], seen = {};
    opt.items.forEach(function (it) {
      Object.keys(it._dims || {}).forEach(function (n) { if (!seen[n]) { seen[n] = 1; names.push(n); } });
    });
    return names.map(function (n) {
      var vals = [];
      opt.items.forEach(function (it) {
        var v = it._ok ? (it._dims || {})[n] : null;
        if (v != null && vals.indexOf(v) === -1) vals.push(v);
      });
      if (vals.length && vals.every(function (v) { return num(v) != null; })) {
        vals.sort(function (a, b) { return (Number(num(a)) - Number(num(b))) || (a < b ? -1 : a > b ? 1 : 0); });
      }
      return { name: n, values: vals };
    }).filter(function (d) { return d.values.length > 1; });
  };

  /* the usable variant that matches `want` and keeps as much of the current choice as it can.
     want: { optionName: 'exact value' | { num: '900' } } */
  Builder.prototype.nearest = function (opt, want) {
    var cur = (opt.items[opt.vsel] || {})._dims || {}, best = -1, score = -1;
    opt.items.forEach(function (it, i) {
      if (!it._ok) return;
      var d = it._dims || {};
      var fits = Object.keys(want).every(function (k) {
        var w = want[k];
        return (w && typeof w === 'object') ? num(d[k]) === w.num : d[k] === w;
      });
      if (!fits) return;
      var s = 0;
      Object.keys(cur).forEach(function (k) { if (d[k] === cur[k]) s += 1; });
      if (s > score) { score = s; best = i; }
    });
    return best;
  };

  Builder.prototype.sizeOf = function (opt) {
    var d = (opt.items[opt.vsel] || {})._dims || {};
    for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k) && isSize(k)) return { dim: k, num: num(d[k]) };
    return null;
  };

  /* size flows down the list: a size picked in one slot (the vanity) is followed by the picked
     items in the slots after it (the mirror cabinet) where they come in that size. Never upwards,
     so a customer can still put a 900 mirror over a 1200 vanity. */
  Builder.prototype.slotIndex = function (slotId) {
    for (var i = 0; i < this.cfg.slots.length; i++) if (this.cfg.slots[i].id === slotId) return i;
    return -1;
  };
  Builder.prototype.followSize = function (fromSlotId, n) {
    var self = this, from = this.slotIndex(fromSlotId);
    if (n == null) return;
    this.cfg.slots.forEach(function (s, idx) {
      if (idx <= from || self.sel[s.id] == null) return;
      var o = self.option(s, self.sel[s.id]);
      if (!o || !o.pick) return;
      var sz = self.sizeOf(o);
      if (!sz || sz.num === n) return;
      var want = {};
      want[sz.dim] = { num: n };
      var i = self.nearest(o, want);
      if (i !== -1) { o.vsel = i; self.adjusted[s.id] = true; }
    });
  };

  /* a newly chosen picked item starts in the size of what it replaces (BOND 1200 -> NUTRA 1200),
     or else the size picked in an earlier slot; then the slots after it follow */
  Builder.prototype.matchSize = function (slotId, opt, was) {
    if (!opt || !opt.pick) return;
    var self = this, sz = this.sizeOf(opt), ref = null, at = this.slotIndex(slotId);
    if (!sz) return;
    var prev = was && was.pick && was !== opt ? this.sizeOf(was) : null;
    if (prev && prev.num) ref = prev.num;
    if (!ref) {
      this.cfg.slots.forEach(function (s, idx) {
        if (idx >= at || self.sel[s.id] == null) return;
        var o = self.option(s, self.sel[s.id]);
        var r = o && o.pick ? self.sizeOf(o) : null;
        if (r && r.num) ref = r.num;          /* the closest earlier slot wins */
      });
    }
    if (ref && ref !== sz.num) {
      var want = {};
      want[sz.dim] = { num: ref };
      var i = this.nearest(opt, want);
      if (i !== -1) opt.vsel = i;
    }
    var now = this.sizeOf(opt);
    if (now) this.followSize(slotId, now.num);
  };

  Builder.prototype.pickValue = function (slotId, dim, val) {
    var slot = this.slot(slotId);
    if (!slot) return;
    var opt = this.option(slot, this.sel[slotId]);
    if (!opt || !opt.pick) return;
    var want = {};
    want[dim] = val;
    var i = this.nearest(opt, want);
    if (i === -1 || i === opt.vsel) return;
    this.adjusted = {};
    opt.vsel = i;
    if (isSize(dim)) this.followSize(slotId, num(val));
    this.error = ''; this.done = false;
    this.focusKey = 'pick-' + slotId + '-' + dim + '-' + val;
    this.render();
  };

  Builder.prototype.backOption = function (slot, sel) {
    var ok = this.choices(slot, sel);
    return ok.filter(function (o) { return o.id === slot.default; })[0] || ok[0] || null;
  };

  Builder.prototype.isBase = function (sel) {
    var self = this;
    sel = sel || this.sel;
    if (this.extras.length) return false;
    for (var q in this.qty) if (Object.prototype.hasOwnProperty.call(this.qty, q) && this.qty[q] !== 1 && sel[q] != null) return false;
    return this.cfg.slots.every(function (s) {
      var cur = sel[s.id] == null ? null : sel[s.id];
      if (cur !== s.default) return false;
      if (cur == null) return true;
      var o = self.option(s, cur);
      return !o || !o.pick || o.vsel === o.vdef;
    });
  };

  Builder.prototype.items = function (sel) {
    var self = this, out = [];
    sel = sel || this.sel;
    this.cfg.slots.forEach(function (slot) {
      var id = sel[slot.id];
      if (id == null) return;
      var opt = self.option(slot, id);
      if (!opt) return;
      var q = self.qty[slot.id] || 1;
      self.optItems(opt).forEach(function (it) { out.push({ slot: slot, opt: opt, it: it, q: q }); });
    });
    /* added lines don't depend on the other choices */
    this.extras.forEach(function (e) {
      var slot = self.slot(e.slot), opt = slot && self.option(slot, e.opt);
      if (!opt || !opt._ok) return;
      self.optItems(opt, e.vsel).forEach(function (it) { out.push({ slot: slot, opt: opt, it: it, q: e.q, extra: e }); });
    });
    return out;
  };

  /* pieces in a list of items, counting quantities */
  Builder.prototype.count = function (items) {
    return items.reduce(function (n, x) { return n + (x.q || 1); }, 0);
  };

  Builder.prototype.rule = function () {
    var d = this.cfg.discount || {};
    return {
      live: d.live !== false && Number(d.auto_pct) > 0,
      pct: Number(d.auto_pct) || 0,
      min: Number(d.min_items) || 0,
      rrpPct: Number(d.rrp_pct) || 0,
      tier: d.tier ? String(d.tier) : null,          // the package's own tier
      tiers: d.tiers || null,                         // tier -> cart discount %
      guestMin: Number(d.guest_min) || 0              // own-tier items needed before other tiers' items get theirs
    };
  };

  /* items of the package's own tier (items without a tier tag count as its own) */
  Builder.prototype.ownCount = function (items) {
    var rule = this.rule();
    if (!rule.tier) return this.count(items);
    return this.count(items.filter(function (x) { return !x.it.tier || String(x.it.tier) === rule.tier; }));
  };

  /* what one product costs in the package.
       'base'   -> unchanged package: its share of the package price (RRP less the package discount)
       'active' -> changed package with the automatic discount: site price less that discount
       'none'   -> below the minimum, or no automatic discount live: site price */
  Builder.prototype.linePrice = function (it, mode, own) {
    var rule = this.rule();
    if (mode === 'base') {
      /* an item whose tier gets no package discount stays at its everyday price */
      if (rule.tier && rule.tiers && it.tier && String(it.tier) !== rule.tier && Number(rule.tiers[String(it.tier)]) === 0) return it._price;
      return Math.round(it._rrp * (1 - rule.rrpPct / 100));
    }
    if (mode === 'active') {
      var pct = rule.pct;
      if (rule.tier && rule.tiers && it.tier && String(it.tier) !== rule.tier) {
        /* an item from a brand with a different discount: its own tier's cart discount, once the
           package has enough of its own tier's items (the store's "Buy X get Y" discount) */
        pct = Number(rule.tiers[String(it.tier)]) || 0;
        if (own != null && own < (rule.guestMin || rule.min)) pct = 0;
      }
      return Math.round(it._price * (1 - pct / 100));
    }
    return it._price;
  };

  Builder.prototype.totals = function (sel) {
    var items = this.items(sel), rule = this.rule(), self = this;
    var count = this.count(items), own = this.ownCount(items);
    var base = this.isBase(sel) && this.pkg.available !== false && !!this.pkg.price;
    var mode = base ? 'base' : (rule.live && own >= rule.min ? 'active' : 'none');
    var rrp = 0, site = 0, pay = 0;
    items.forEach(function (x) { var q = x.q || 1; rrp += x.it._rrp * q; site += x.it._price * q; pay += self.linePrice(x.it, mode, own) * q; });
    if (base) {
      pay = this.pkg.price;
      if (this.pkg.compare_at_price && this.pkg.compare_at_price > this.pkg.price) rrp = this.pkg.compare_at_price;
    }
    return { count: count, own: own, base: base, mode: mode, active: mode !== 'none', rrp: rrp, site: site, pay: pay,
      save: Math.max(0, rrp - pay), short: Math.max(0, rule.min - own) };
  };

  /* ------------------------------------------------------------ cart */
  Builder.prototype.baseProperties = function () {
    var self = this, props = {}, n = 0;
    this.cfg.slots.forEach(function (slot) {
      var id = self.sel[slot.id];
      if (id == null) return;
      var opt = self.option(slot, id);
      n += 1;
      props[n + '. ' + slot.label] = self.optItems(opt).map(function (it) {
        var sku = it._v.sku || it.sku;
        return it._title + (it._vt ? ', ' + it._vt : '') + (sku ? ' (' + sku + ')' : '');
      }).join(' + ');
    });
    props._bbpkg = this.cfg.id || 'package';
    return props;
  };

  Builder.prototype.payload = function (qty) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    if (this.isBase() && this.pkg.variant_id && this.pkg.available !== false) {
      return { mode: 'package', items: [{ id: this.pkg.variant_id, quantity: qty, properties: this.baseProperties() }] };
    }
    var group = uid(), name = this.cfg.name || this.pkg.title || 'Package', map = {}, lines = [];
    this.items().forEach(function (x) {
      var key = String(x.it._v.id), n = qty * (x.q || 1);
      if (map[key]) { map[key].quantity += n; return; }
      map[key] = { id: x.it._v.id, quantity: n, properties: { Package: name, _bbpkg: group } };
      lines.push(map[key]);
    });
    return { mode: 'items', items: lines };
  };

  Builder.prototype.addToCart = function (qty) {
    var self = this;
    if (this.busy || !this.ready) return Promise.resolve(false);
    var body = this.payload(qty);
    if (!body.items.length) return Promise.resolve(false);
    this.busy = true; this.error = ''; this.render();
    return fetch(rootPath() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: body.items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'The cart did not accept these items.');
        return j;
      });
    }).then(function () {
      self.host.dispatchEvent(new CustomEvent('bbpkg:added', { bubbles: true, detail: body }));
      var go = self.host.getAttribute('data-after-add') || 'cart';
      if (go === 'stay') { self.busy = false; self.done = true; self.render(); return true; }
      window.location.href = rootPath() + (go === 'checkout' ? 'checkout' : 'cart');
      return true;
    }).catch(function (e) {
      self.busy = false;
      self.error = (e && e.message) || 'Something went wrong adding the package. Please try again.';
      self.render();
      return false;
    });
  };

  /* ------------------------------------------------------------ the theme's own product form */
  Builder.prototype.findForm = function () {
    if (this._form !== undefined) return this._form;
    var want = String(this.pkg.variant_id || '');
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    this._form = null;
    for (var i = 0; i < forms.length; i++) {
      if (this.host.contains(forms[i])) continue;
      var idEl = forms[i].querySelector('[name="id"]');
      if (idEl && String(idEl.value) === want) { this._form = forms[i]; break; }
    }
    return this._form;
  };

  Builder.prototype.addButton = function () {
    var f = this.findForm();
    return f ? f.querySelector('[name="add"], .add_to_cart, [type="submit"]') : null;
  };

  Builder.prototype.hookForm = function () {
    var self = this, form = this.findForm();
    if (!form) return;
    this.form = form;
    this.onFormClick = function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[name="add"], .add_to_cart, [type="submit"]') : null;
      if (!t || !form.contains(t) || !self.ready || self.isBase()) return;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var q = form.querySelector('[name="quantity"]');
      self.addToCart(q ? q.value : 1);
    };
    this.onFormSubmit = function (e) {
      if (!self.ready || self.isBase()) return;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var q = form.querySelector('[name="quantity"]');
      self.addToCart(q ? q.value : 1);
    };
    form.addEventListener('click', this.onFormClick, true);
    form.addEventListener('submit', this.onFormSubmit, true);

    if (this.mode === 'section') {
      var note = document.createElement('div');
      note.setAttribute('data-bbpkg-note', '');
      note.style.cssText = 'margin:14px 0 0;padding:12px 14px;border-left:3px solid var(--bbpkg-accent,#a18e6b);background:var(--bbpkg-bg,#fbf4ec);font-size:14px;line-height:1.5;';
      var buttons = form.querySelector('.purchase-details') || form.lastElementChild;
      if (buttons && buttons.parentNode === form) form.insertBefore(note, buttons.nextSibling); else form.appendChild(note);
      this.note = note;
      note.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('[data-bbpkg-jump]') : null;
        if (!a) return;
        e.preventDefault();
        self.host.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    this.syncForm();
  };

  Builder.prototype.unhookForm = function () {
    if (!this.form) return;
    this.form.removeEventListener('click', this.onFormClick, true);
    this.form.removeEventListener('submit', this.onFormSubmit, true);
    var old = this.form.querySelector('[data-bbpkg-props]');
    if (old) old.parentNode.removeChild(old);
    if (this.note && this.note.parentNode) this.note.parentNode.removeChild(this.note);
    this.form = null;
  };

  /* the standard button always sells what the list shows */
  Builder.prototype.syncForm = function () {
    if (!this.form) return;
    var old = this.form.querySelector('[data-bbpkg-props]');
    if (old) old.parentNode.removeChild(old);
    var t = this.totals();
    if (t.base) {
      var wrap = document.createElement('span');
      wrap.setAttribute('data-bbpkg-props', '');
      wrap.hidden = true;
      var props = this.baseProperties();
      Object.keys(props).forEach(function (k) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = props[k];
        wrap.appendChild(i);
      });
      this.form.appendChild(wrap);
    }
    if (this.note) {
      var link = '<a href="#" data-bbpkg-jump style="text-decoration:underline;">' + esc(this.txt.jump || 'Change or remove items') + '</a>';
      this.note.innerHTML = t.base
        ? esc(fill(this.txt.note_base || 'This package includes {count} items.', { count: t.count })) + ' ' + link
        : '<strong>' + esc(fill(this.txt.note_custom || 'Your version: {count} items, {price}.', { count: t.count, price: money(t.pay, this.moneyFormat) })) + '</strong> ' +
          esc(this.txt.note_custom_2 || 'Add to cart adds your version.') + ' ' + link;
    }
  };

  /* ------------------------------------------------------------ the theme's price at the top of the page */
  Builder.prototype.priceBox = function () {
    if (this._priceBox !== undefined) return this._priceBox;
    var form = this.findForm();
    var scope = (form && (form.closest('.product_section') || form.closest('.product-main'))) || document;
    this._priceBox = scope.querySelector('.product-block--price .price-ui') || scope.querySelector('.price-ui') || null;
    if (this._priceBox) this._priceOriginal = this._priceBox.innerHTML;
    return this._priceBox;
  };

  Builder.prototype.restorePrice = function () {
    if (this._priceBox && this._priceOriginal != null) this._priceBox.innerHTML = this._priceOriginal;
  };

  Builder.prototype.syncPrice = function (t) {
    var box = this.priceBox();
    if (!box) return;
    if (t.base) { this.restorePrice(); return; }
    var fmt = this.moneyFormat;
    var pct = t.rrp ? Math.round((t.save / t.rrp) * 100) : 0;
    var html = '<span class="price' + (t.save > 0 ? ' price--sale' : '') + '"><span class="money">' + esc(money(t.pay, fmt)) + '</span></span>';
    if (t.save > 0) {
      html += ' <span class="compare-at-price"><span class="money">' + esc(money(t.rrp, fmt)) + '</span></span>' +
        ' <span class="sale savings">' + esc(this.txt.price_save || 'You Save') + ' ' + pct + '% (<span class="money">' + esc(money(t.save, fmt)) + '</span>)</span>';
    }
    box.innerHTML = html;
  };

  /* ------------------------------------------------------------ view */
  var MAXQ = 5;
  /* lines where a second product makes a second room, not a second piece */
  var NO_MORE_KEY = /^(vanity|vanities|toilet|toilet-suite|mirror|mirror-cabinet|cabinet|bath|bathtub|bath-tap|bath-waste|arm|shower-arm|bidet-suite|bidet)$/i;
  var NO_MORE_LABEL = /^(vanity|toilet( suite)?|mirror( cabinet)?|bath)$/i;
  /* round or square (rectangular) plate, read from the option name */
  function shapeOf(o) {
    var l = String(o && o.label || '').toLowerCase();
    return /\bround\b/.test(l) ? 'round' : /\b(square|rectangular|rectangle)\b/.test(l) ? 'square' : '';
  }
  function slotKey(slot) { return String(slot && slot.id || '').replace(/^.*-slot-/, '').replace(/_/g, '-'); }
  /* option notes written for the old inline list ("Pick the size below") */
  function cleanNote(n) {
    return String(n || '').replace(/;\s*(pick|choose) the [^.]*\./gi, '.').replace(/\s*(Pick|Choose) the [^.]*\.\s*/g, ' ').trim();
  }
  function safeHTML(h) {
    return String(h || '').replace(/<(script|style|iframe|object|embed)[\s\S]*?<\/\1>/gi, '').replace(/\son\w+="[^"]*"/gi, '');
  }

  Builder.prototype.canAddAnother = function (slot) {
    if (NO_MORE_KEY.test(slotKey(slot)) || NO_MORE_LABEL.test(String(slot.label || '').trim())) return false;
    return this.addable(slot).length > 0;
  };

  /* "Add another" means a different model: same model is the quantity stepper */
  Builder.prototype.addable = function (slot) {
    var self = this, cur = this.sel[slot.id];
    var taken = this.extras.filter(function (e) { return e.slot === slot.id; }).map(function (e) { return e.opt; });
    return slot.options.filter(function (o) { return o._ok && o.id !== cur && taken.indexOf(o.id) < 0; });
  };

  Builder.prototype.extra = function (key) {
    return this.extras.filter(function (e) { return e.key === key; })[0] || null;
  };

  /* one more or one fewer of a line; never above 5 or below the package minimum */
  Builder.prototype.setQty = function (slotId, delta) {
    var q = (this.qty[slotId] || 1) + delta;
    if (q < 1 || q > MAXQ) return;
    if (delta < 0 && this.count(this.items()) - 1 < (this.floor || 0)) return;
    this.qty[slotId] = q;
    this.error = ''; this.done = false;
    this.focusKey = 'qty-' + (delta > 0 ? 'up-' : 'down-') + slotId;
    this.render();
  };
  Builder.prototype.setExtraQty = function (key, delta) {
    var e = this.extra(key);
    if (!e) return;
    var q = e.q + delta;
    if (q < 1 || q > MAXQ) return;
    if (delta < 0 && this.count(this.items()) - 1 < (this.floor || 0)) return;
    e.q = q;
    this.focusKey = 'xqty-' + (delta > 0 ? 'up-' : 'down-') + key;
    this.render();
  };
  Builder.prototype.removeExtra = function (key) {
    var e = this.extra(key);
    if (!e) return;
    if (this.count(this.items()) - e.q < (this.floor || 0)) return;
    this.extras = this.extras.filter(function (x) { return x !== e; });
    this.render();
  };
  Builder.prototype.pickExtra = function (key, dim, val) {
    var e = this.extra(key), slot = e && this.slot(e.slot), opt = slot && this.option(slot, e.opt);
    if (!opt || !opt.pick) return;
    var save = opt.vsel, want = {};
    want[dim] = val;
    opt.vsel = e.vsel;
    var i = this.nearest(opt, want);
    opt.vsel = save;
    if (i === -1) return;
    e.vsel = i;
    this.focusKey = 'xpick-' + key + '-' + dim + '-' + val;
    this.render();
  };

  /* ------------------------------------------------------------ double-bowl vanity */
  Builder.prototype.findSlot = function (keys, label) {
    return this.cfg.slots.filter(function (s) { return keys.test(slotKey(s)) || label.test(String(s.label || '')); })[0] || null;
  };
  Builder.prototype.doubleBowl = function () {
    var self = this, hit = null;
    this.cfg.slots.forEach(function (s) {
      if (hit || self.sel[s.id] == null) return;
      if (!/vanit/i.test(slotKey(s) + ' ' + s.label)) return;
      var it = self.optItems(self.option(s, self.sel[s.id]))[0];
      if (it && /double/i.test(it._vt || '')) hit = { slot: s, vid: it._v.id };
    });
    if (!hit || this.doubleSeen[hit.vid]) return null;
    hit.add = [
      this.findSlot(/^basin-?mix/i, /basin mixer/i),
      this.findSlot(/^(waste|basin-waste|pop-?up)$/i, /^basin waste/i),
      this.findSlot(/^basin$/i, /^basin$/i)
    ].filter(function (s) { return s && self.sel[s.id] != null; });
    return hit.add.length ? hit : null;
  };
  Builder.prototype.answerDouble = function (yes) {
    var self = this, d = this.doubleBowl();
    if (!d) return;
    this.doubleSeen[d.vid] = true;
    if (yes) d.add.forEach(function (s) { self.qty[s.id] = Math.min(MAXQ, (self.qty[s.id] || 1) + 1); });
    this.focusKey = 'tray-' + d.slot.id;
    this.render();
  };

  /* ------------------------------------------------------------ more showers than mixers */
  Builder.prototype.lineCount = function (slot) {
    if (!slot || this.sel[slot.id] == null) return 0;
    var n = this.qty[slot.id] || 1;
    this.extras.forEach(function (e) { if (e.slot === slot.id) n += e.q; });
    return n;
  };
  Builder.prototype.showerGap = function () {
    var shower = this.findSlot(/^shower$/i, /^shower$/i);
    var mixer = this.findSlot(/^(mixer|shower-mixer|control)$/i, /^shower mixer$/i);
    if (!shower || !mixer || this.sel[shower.id] == null || this.sel[mixer.id] == null) return null;
    var n = this.lineCount(shower), m = this.lineCount(mixer);
    if (n <= m || this.mixerSeen[n + ':' + m]) return null;
    return { shower: shower, mixer: mixer, n: n, m: m };
  };
  Builder.prototype.answerMixer = function (yes) {
    var g = this.showerGap();
    if (!g) return;
    this.mixerSeen[g.n + ':' + g.m] = true;
    if (yes) this.qty[g.mixer.id] = Math.min(MAXQ, (this.qty[g.mixer.id] || 1) + (g.n - g.m));
    this.focusKey = 'tray-' + g.shower.id;
    this.render();
  };
  Builder.prototype.gapHTML = function (g) {
    var txt = this.txt, extra = g.n - g.m;
    return '<div class="pk-prompt" role="note"><p class="pk-prompt__text"><strong>' + esc(txt.mixer_title || 'More showers than mixers') + '</strong> ' +
      esc(fill(txt.mixer_text || 'You have {n} showers and {mixers}. Each shower needs its own mixer.', { n: g.n, mixers: g.m === 1 ? (txt.mixer_one || '1 shower mixer') : fill(txt.mixer_many || '{m} shower mixers', { m: g.m }) })) + '</p>' +
      '<div class="pk-prompt__acts"><button type="button" class="pk-add" data-act="mixer" data-yes="1" data-key="mixer-yes">' + esc(extra > 1 ? fill(txt.mixer_yes_n || 'Add {extra} mixers', { extra: extra }) : (txt.mixer_yes || 'Add a mixer')) + '</button>' +
      '<button type="button" class="pk-act pk-act--quiet" data-act="mixer" data-yes="0" data-key="mixer-no">' + esc(txt.mixer_no || 'No thanks') + '</button></div></div>';
  };

  /* ------------------------------------------------------------ mount */
  Builder.prototype.mount = function () {
    var self = this;
    var mountEl = null;
    this.mode = 'section';
    if (this.position === 'inline') {
      var form = this.findForm();
      var anchor = form && (form.querySelector('.purchase-details') || (this.addButton() && this.addButton().parentNode));
      if (anchor && anchor.parentNode) {
        mountEl = document.createElement('div');
        mountEl.setAttribute('data-bbpkg-inline', '');
        mountEl.style.cssText = 'display:block;margin:0 0 20px;';
        anchor.parentNode.insertBefore(mountEl, anchor);
        this.inlineEl = mountEl;
        this.mode = 'inline';
      }
    }
    var band = this.host.closest('.bbpkg-section');
    if (this.mode === 'inline' && band) { band.setAttribute('hidden', ''); band.style.display = 'none'; }
    if (!mountEl) {
      mountEl = this.host.querySelector('[data-bbpkg-app]');
      if (!mountEl) { mountEl = document.createElement('div'); this.host.appendChild(mountEl); }
    }
    var css = this.host.getAttribute('data-css');
    function shadow(el, cls) {
      ['--bbpkg-bg', '--bbpkg-text', '--bbpkg-accent'].forEach(function (v) {
        var val = band && band.style.getPropertyValue(v);
        if (val) el.style.setProperty(v, val.trim());
      });
      var root = el.attachShadow ? el.attachShadow({ mode: 'open' }) : el;
      if (css) {
        var l = document.createElement('link');
        l.rel = 'stylesheet'; l.href = css;
        root.appendChild(l);
      }
      var view = document.createElement('div');
      view.className = cls;
      root.appendChild(view);
      return { root: root, view: view };
    }
    var main = shadow(mountEl, 'pk pk--' + this.mode);
    this.root = main.root;
    this.view = main.view;

    /* the phone bar, the change panel and the specs popup live on the page body: the theme's
       product column can be transformed or clipped, which would trap fixed-position elements */
    var layerHost = document.createElement('div');
    layerHost.setAttribute('data-bbpkg-layer', '');
    document.body.appendChild(layerHost);
    var layer = shadow(layerHost, 'pk pk-layer');
    this.layerHost = layerHost;
    this.layerRoot = layer.root;
    this.layer = layer.view;

    var onClick = function (e) { self.onClick(e); };
    this.view.addEventListener('click', onClick);
    this.layer.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && (self.sheet || self.specs || self.zoom)) { e.preventDefault(); self.closeTop(); }
    });

    this.hideThemeBits();

    if ('IntersectionObserver' in window) {
      this.seen = { list: false, cta: false };
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === mountEl) self.seen.list = en.isIntersecting;
          else self.seen.cta = en.isIntersecting;
        });
        self.syncBar();
      }, { threshold: 0 });
      this.io.observe(mountEl);
      if (this.mode === 'inline') {
        var btn = this.addButton();
        if (btn) { this.io.observe(btn); this.ctaEl = btn; }
      }
    }
  };

  /* the theme's own product details that mean nothing on a package: its internal code and the
     one-value colour picker (the Colour option itself stays, the collection filter uses it) */
  Builder.prototype.hideThemeBits = function () {
    var form = this.findForm();
    var scope = (form && (form.closest('.product__details') || form.closest('.product_section'))) || null;
    if (!scope) return;
    var range = String(this.cfg.range || '').trim().toLowerCase();
    Array.prototype.forEach.call(scope.querySelectorAll('.product-block--sku'), function (el) { el.style.display = 'none'; });
    Array.prototype.forEach.call(scope.querySelectorAll('.swatch_options'), function (el) {
      var n = Math.max(el.querySelectorAll('.swatch-element').length, el.querySelectorAll('input[type="radio"]').length);
      if (n <= 1) el.style.display = 'none';
    });
    if (range) {
      Array.prototype.forEach.call(scope.querySelectorAll('.product-block--text'), function (el) {
        if (el.textContent.trim().toLowerCase() === range) el.style.display = 'none';
      });
    }
  };

  Builder.prototype.syncBar = function () {
    var bar = this.layer && this.layer.querySelector('.pk-bar');
    if (!bar) return;
    var show = this.seen ? (this.seen.list && !this.seen.cta) : false;
    if (this.sheet || this.specs || this.zoom) show = false;
    bar.classList.toggle('is-shown', !!show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  };

  /* ------------------------------------------------------------ clicks */
  Builder.prototype.onClick = function (e) {
    var self = this;
    var b = e.target && e.target.closest ? e.target.closest('[data-act]') : null;
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    var act = b.getAttribute('data-act'), slot = b.getAttribute('data-slot'), key = b.getAttribute('data-key-x');
    if (b.tagName === 'A' && act !== 'specs') return;
    if (act === 'tray') this.openSheet('swap', slot, null, b);
    else if (act === 'another') this.openSheet('add', slot, null, b);
    else if (act === 'xchange') this.openSheet('extra', slot, key, b);
    else if (act === 'choose') this.chooseFromSheet(b.getAttribute('data-opt'));
    else if (act === 'remove') this.remove(slot);
    else if (act === 'xremove') this.removeExtra(key);
    else if (act === 'restore') this.restore(slot);
    else if (act === 'reset') this.reset();
    else if (act === 'more') { this.expanded = !this.expanded; this.focusKey = 'more'; this.render(); }
    else if (act === 'pick') { if (key) this.pickExtra(key, b.getAttribute('data-dim'), b.getAttribute('data-val')); else this.pickValue(slot, b.getAttribute('data-dim'), b.getAttribute('data-val')); }
    else if (act === 'qty') this.setQty(slot, Number(b.getAttribute('data-d')));
    else if (act === 'xqty') this.setExtraQty(key, Number(b.getAttribute('data-d')));
    else if (act === 'double') this.answerDouble(b.getAttribute('data-yes') === '1');
    else if (act === 'mixer') this.answerMixer(b.getAttribute('data-yes') === '1');
    else if (act === 'specs') { e.preventDefault(); this.openSpecs(b.getAttribute('data-h'), b.getAttribute('data-v'), b.getAttribute('data-slot-label'), b); }
    else if (act === 'zoom') { this.zoom = b.getAttribute('data-src'); this.zoomBig = false; this.renderLayer(); this.focusIn('.pk-zoom .pk-x'); }
    else if (act === 'zoomflip') {
      var z = this.layer.querySelector('.pk-zoom'), im = z && z.querySelector('img'), fx = .5, fy = .5;
      if (im && !this.zoomBig && e.clientX != null) { var rc = im.getBoundingClientRect(); if (rc.width && rc.height) { fx = Math.min(1, Math.max(0, (e.clientX - rc.left) / rc.width)); fy = Math.min(1, Math.max(0, (e.clientY - rc.top) / rc.height)); } }
      this.zoomBig = !this.zoomBig;
      if (z) {
        z.classList.toggle('is-big', this.zoomBig);
        if (this.zoomBig) { var sc = b, r2 = im.getBoundingClientRect(); sc.scrollLeft = Math.max(0, r2.width * fx - sc.clientWidth / 2); sc.scrollTop = Math.max(0, r2.height * fy - sc.clientHeight / 2); }
      }
    }
    else if (act === 'close') this.closeTop();
    else if (act === 'add') {
      if (this.isBase() && this.mode === 'inline' && this.addButton()) { this.addButton().click(); return; }
      var q = self.form && self.form.querySelector('[name="quantity"]');
      this.addToCart(q ? q.value : 1);
    }
  };

  /* ------------------------------------------------------------ panels */
  Builder.prototype.lock = function () {
    var on = !!(this.sheet || this.specs || this.zoom);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };
  Builder.prototype.focusIn = function (sel) {
    var el = this.layer && this.layer.querySelector(sel);
    if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  };
  Builder.prototype.openSheet = function (mode, slotId, key, from) {
    this.sheet = { mode: mode, slot: slotId, key: key || null };
    this.returnTo = from || null;
    this.renderLayer();
    this.focusIn('.pk-sheet .pk-x');
  };
  Builder.prototype.closeTop = function () {
    if (this.zoom) { this.zoom = null; this.renderLayer(); this.focusIn('.pk-pop .pk-x'); return; }
    if (this.specs) {
      this.specs = null; this.renderLayer();
      if (this.sheet) this.focusIn('.pk-sheet .pk-x'); else this.restoreFocus();
      return;
    }
    if (this.sheet) { this.sheet = null; this.renderLayer(); this.restoreFocus(); }
  };
  Builder.prototype.restoreFocus = function () {
    var r = this.returnTo;
    this.returnTo = null;
    if (!r) return;
    var k = r.getAttribute && r.getAttribute('data-key');
    var el = k ? this.view.querySelector('[data-key="' + k + '"]') : null;
    el = el || r;
    if (el && el.focus && el.isConnected) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  };
  Builder.prototype.chooseFromSheet = function (optId) {
    var sh = this.sheet;
    if (!sh) return;
    var slot = this.slot(sh.slot), opt = slot && this.option(slot, optId);
    if (!opt) return;
    if (sh.mode === 'swap') {
      this.sheet = null;
      this.choose(sh.slot, optId);
    } else if (sh.mode === 'add') {
      this.sheet = null;
      this.extras.push({ key: uid(), slot: sh.slot, opt: optId, q: 1, vsel: opt.pick ? opt.vsel : 0 });
      this.render();
    } else if (sh.mode === 'extra') {
      var e = this.extra(sh.key);
      this.sheet = null;
      if (e) { e.opt = optId; e.vsel = opt.pick ? opt.vsel : 0; }
      this.render();
    }
    this.restoreFocus();
  };

  /* ------------------------------------------------------------ specs popup */
  Builder.prototype.openSpecs = function (handle, vid, slotLabel, from) {
    var self = this;
    if (!handle) return;
    var found = null;
    this.cfg.slots.forEach(function (s) {
      s.options.forEach(function (o) {
        o.items.forEach(function (it) { if (!found && it.handle === handle && it._v && String(it._v.id) === String(vid)) found = it; });
      });
    });
    if (!this.sheet) this.returnTo = from || null;
    this.specs = { handle: handle, vid: String(vid || ''), it: found, label: slotLabel || '', data: this.specCache[handle] || null };
    this.renderLayer();
    this.focusIn('.pk-pop .pk-x');
    if (this.specs.data) return;
    var base = rootPath() + 'products/' + encodeURIComponent(handle);
    fetch(base + '?view=bbpkg-specs', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('view ' + r.status); return r.text(); })
      .then(function (t) { var j = JSON.parse(t); j.source = 'view'; return j; })
      .catch(function () {
        /* the specs view isn't on this theme: photos and description from the product's JSON */
        return getJSON(base + '.js').then(function (p) {
          var att = {};
          (p.variants || []).forEach(function (v) {
            if (v.featured_image && v.featured_image.src) {
              var k = String(v.featured_image.src).split('?')[0].replace(/^https?:/, '');
              (att[k] = att[k] || []).push(v.id);
            }
          });
          return {
            source: 'js', title: p.title, url: p.url, description: p.description || '', specs: '',
            images: (p.images || []).map(function (src) { var k = String(src).split('?')[0].replace(/^https?:/, ''); return { src: src, variants: att[k] || [] }; })
          };
        });
      })
      .then(function (d) { self.specCache[handle] = d; if (self.specs && self.specs.handle === handle) { self.specs.data = d; self.renderLayer(); } })
      .catch(function () { if (self.specs && self.specs.handle === handle) { self.specs.data = { failed: true }; self.renderLayer(); } });
  };

  /* the photos for this variant's finish: its own photo, the finish's other photos, photos that
     suit every finish, room shots in the finish, then the drawings (always kept) */
  var DRAWING_NAME = /(spec|schem|shematic|diagram|drawing|measure|dimension|technical|install|_S(?:[-_.]|\d|$)|E5_B0_BA_E5_AF_B8)/i;
  var FINISH_WORDS = /(chrome|black|nickel|gun ?metal|gunmetal|shadow|gold|bronze|brass|champagne|copper|carbon|white|grey)/i;
  function imgStem(src) {
    var f = String(src || '').split('?')[0].split('/').pop();
    try { f = decodeURIComponent(f); } catch (e) {}
    return f.replace(/\.(png|jpe?g|webp|gif)$/i, '');
  }
  Builder.prototype.specImages = function (d, vid) {
    var imgs = d.images || [], m = d.media, v = String(vid), MAX = 24;
    if (m && m.i && typeof m.i === 'object') {
      var f = m.vf && m.vf[v] != null ? +m.vf[v] : null, many = (m.f || []).length > 1;
      var fits = function (c) {
        if (c === 'x') return false;
        if (!many || f == null || c === 'a' || c === 'd') return true;
        var k = c.charAt(0), rest = c.slice(1);
        if (k === 'p' || k === 's') return parseInt(rest, 36) === f;
        if (k === 'm') return rest.split('.').some(function (x) { return parseInt(x, 36) === f; });
        return false;
      };
      var own = [], photos = [], all = [], rooms = [], draws = [];
      imgs.forEach(function (im) {
        var vs = (im.variants || []).map(String), c = m.i[imgStem(im.src)];
        if (c == null) {
          /* a photo added after the map was made: attached ones follow their variant, the rest are shared */
          if (vs.length) { if (vs.indexOf(v) !== -1) own.push(im); }
          else if (DRAWING_NAME.test(imgStem(im.src))) draws.push(im);
          else all.push(im);
          return;
        }
        if (!fits(c)) return;
        if (c === 'd') draws.push(im);
        else if (vs.indexOf(v) !== -1 && c !== 'a') own.push(im);
        else if (c.charAt(0) === 's') rooms.push(im);
        else if (c === 'a') (vs.indexOf(v) !== -1 ? own : all).push(im);
        else photos.push(im);
      });
      var room = Math.max(0, MAX - draws.length);
      var list = own.concat(photos, all, rooms).slice(0, room).concat(draws);
      if (list.length) return list;
    }
    /* no map: own photo, shared photos that don't name another finish, drawings last and never cut */
    var mine = [], shared = [], dr = [];
    imgs.forEach(function (im) {
      var vs = (im.variants || []).map(String), s = imgStem(im.src);
      if (vs.length) { if (vs.indexOf(v) !== -1) mine.push(im); return; }
      if (DRAWING_NAME.test(s)) dr.push(im);
      else if (!FINISH_WORDS.test(s.replace(/[_\-]+/g, ' '))) shared.push(im);
    });
    var out = mine.concat(shared).slice(0, Math.max(1, 12 - dr.length)).concat(dr);
    return out.length ? out : imgs.slice(0, 1);
  };

  Builder.prototype.specsHTML = function () {
    var s = this.specs, d = s.data, it = s.it, fmt = this.moneyFormat, txt = this.txt, t = this.totals();
    var title = (it && it._title) || (d && d.title) || '';
    var head = '<header class="pk-sheet__head"><div class="pk-sheet__titles">' + (s.label ? '<p class="pk-sheet__kicker">' + esc(s.label) + '</p>' : '') +
      '<h3 class="pk-sheet__title" id="pk-pop-title">' + esc(title) + '</h3></div>' +
      '<button type="button" class="pk-x" data-act="close" aria-label="' + esc(txt.close || 'Close') + '"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg></button></header>';
    var body = '';
    if (!d) body = '<p class="pk-pop__wait">' + esc(txt.loading || 'Loading details…') + '</p>';
    else {
      var imgs = d.failed ? [] : this.specImages(d, s.vid);
      if (!imgs.length && it && it._img) imgs = [{ src: it._img }];
      if (imgs.length) {
        body += '<div class="pk-gal" tabindex="0" aria-label="' + esc(txt.photos || 'Photos') + '">' + imgs.map(function (im, i) {
          return '<button type="button" class="pk-gal__item" data-act="zoom" data-src="' + esc(imgUrl(im.src, 2000)) + '" aria-label="' + esc((txt.zoom || 'Zoom photo') + ' ' + (i + 1)) + '">' +
            '<img src="' + esc(imgUrl(im.src, 900)) + '" alt="' + esc(im.alt || title) + '" loading="' + (i ? 'lazy' : 'eager') + '"></button>';
        }).join('') + '</div>' +
          '<p class="pk-gal__hint">' + esc(imgs.length > 1 ? (txt.swipe || 'Swipe for more photos. Tap a photo to zoom.') : (txt.tap_zoom || 'Tap the photo to zoom.')) + '</p>';
      }
      var facts = [];
      if (it && it._vt) facts.push([txt.option || 'Option', it._vt]);
      if (it && (it._v.sku || it.sku)) facts.push([txt.code || 'Product code', it._v.sku || it.sku]);
      if (it) facts.push([txt.price_here || 'Price in this package', money(this.linePrice(it, t.mode, t.own), fmt)]);
      if (facts.length) body += '<dl class="pk-facts">' + facts.map(function (f) { return '<div><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('') + '</dl>';
      var spec = d.specs ? safeHTML(d.specs) : '';
      var details = (d.details || []).filter(function (x) { return x && x.value; });
      if (spec || details.length) {
        body += '<h4 class="pk-pop__h">' + esc(txt.specs_title || 'Specifications & warranty') + '</h4>';
        if (spec) body += '<div class="pk-spec">' + spec + '</div>';
        else body += '<dl class="pk-facts pk-facts--spec">' + details.map(function (x) { return '<div><dt>' + esc(x.label) + '</dt><dd>' + esc(x.value) + '</dd></div>'; }).join('') + '</dl>';
      }
      if (d.description) {
        body += '<details class="pk-desc"' + (spec || details.length ? '' : ' open') + '><summary>' + esc(txt.description || 'Product description') + '</summary><div class="pk-desc__body">' + safeHTML(d.description) + '</div></details>';
      }
      if (d.failed) body += '<p class="pk-pop__wait">' + esc(txt.load_failed || "We couldn't load the details just now.") + '</p>';
      var links = [];
      if (d.sheet) links.push('<a href="' + esc(d.sheet) + '" target="_blank" rel="noopener">' + esc(txt.sheet || 'Specification sheet') + '</a>');
      var url = (it && it._url) || (d && d.url) || (rootPath() + 'products/' + s.handle);
      links.push('<a href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(txt.full_page || 'View the full product page') + '</a>');
      body += '<p class="pk-links">' + links.join('') + '</p>';
    }
    return '<div class="pk-scrim pk-scrim--pop" data-act="close"></div>' +
      '<section class="pk-pop" role="dialog" aria-modal="true" aria-labelledby="pk-pop-title">' + head + '<div class="pk-pop__body">' + body + '</div></section>';
  };

  /* ------------------------------------------------------------ change / add panel */
  Builder.prototype.sheetHTML = function () {
    var self = this, sh = this.sheet, txt = this.txt, t = this.totals(), fmt = this.moneyFormat;
    var slot = this.slot(sh.slot);
    if (!slot) return '';
    var e = sh.mode === 'extra' ? this.extra(sh.key) : null;
    var current = sh.mode === 'swap' ? this.sel[slot.id] : (e ? e.opt : null);
    var list = sh.mode === 'swap' ? this.choices(slot) : sh.mode === 'add' ? this.addable(slot) : slot.options.filter(function (o) { return o._ok; });
    var title = sh.mode === 'add' ? (txt.add_another_title || 'Add another') : (txt.change_title || 'Change');
    var lead = sh.mode === 'add' ? (txt.add_another_lead || 'Added as an extra line. Your current choice stays.') : '';
    var rows = list.map(function (o) {
      var on = o.id === current, ok = true, tag;
      if (sh.mode === 'swap') {
        ok = on || self.canChoose(slot, o);
        if (on) tag = esc(txt.selected || 'In your package');
        else if (!ok) tag = esc(fill(txt.floor_short || 'Below {min} items', { min: self.floor }));
        else tag = self.diffTag(self.totals(self.preview(slot.id, o.id)).pay - t.pay);
      } else if (sh.mode === 'add') {
        self.extras.push({ key: '_peek', slot: slot.id, opt: o.id, q: 1, vsel: o.pick ? o.vsel : 0 });
        var after = self.totals().pay;
        self.extras.pop();
        tag = '+ ' + money(after - t.pay, fmt);
      } else {
        if (on) tag = esc(txt.selected || 'In your package');
        else {
          var was = { opt: e.opt, vsel: e.vsel };
          e.opt = o.id; e.vsel = o.pick ? o.vsel : 0;
          var p2 = self.totals().pay;
          e.opt = was.opt; e.vsel = was.vsel;
          tag = self.diffTag(p2 - t.pay);
        }
      }
      var its = self.optItems(o);
      var values = o.pick ? self.dims(o).map(function (d) { return '<span class="pk-opt2__vals">' + esc(d.name) + ': ' + esc(d.values.join(' · ')) + '</span>'; }).join('') : '';
      var note = cleanNote(o.note);
      var first = its[0];
      return '<div class="pk-opt2' + (on ? ' is-on' : '') + (ok ? '' : ' is-off') + '">' +
        '<button type="button" class="pk-opt2__main" data-act="choose" data-opt="' + esc(o.id) + '"' + (ok && !on ? '' : ' disabled') + (on ? ' aria-current="true"' : '') + '>' +
          '<span class="pk-opt2__media">' + its.slice(0, 3).map(function (it) { return self.thumb(it, its.length > 1 ? 40 : 64); }).join('') + '</span>' +
          '<span class="pk-opt2__text"><span class="pk-opt2__name">' + esc(o.label) + '</span>' +
            (note ? '<span class="pk-opt2__note">' + esc(note) + '</span>' : '') + values + '</span>' +
          '<span class="pk-opt2__tag">' + tag + '</span>' +
        '</button>' +
        (first ? '<button type="button" class="pk-opt2__specs" data-act="specs" data-h="' + esc(first.handle) + '" data-v="' + esc(first._v.id) + '" data-slot-label="' + esc(slot.label) + '">' + esc(txt.see_specs || 'See specs') + '</button>' : '') +
        '</div>';
    }).join('');
    return '<div class="pk-scrim" data-act="close"></div>' +
      '<section class="pk-sheet" role="dialog" aria-modal="true" aria-labelledby="pk-sheet-title">' +
        '<header class="pk-sheet__head"><div class="pk-sheet__titles"><p class="pk-sheet__kicker">' + esc(slot.label) + '</p>' +
          '<h3 class="pk-sheet__title" id="pk-sheet-title">' + esc(title) + '</h3></div>' +
          '<button type="button" class="pk-x" data-act="close" aria-label="' + esc(txt.close || 'Close') + '"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg></button></header>' +
        '<div class="pk-sheet__body">' + (lead ? '<p class="pk-sheet__lead">' + esc(lead) + '</p>' : '') + rows + '</div>' +
      '</section>';
  };

  Builder.prototype.barHTML = function (t) {
    var fmt = this.moneyFormat, txt = this.txt;
    return '<div class="pk-bar" aria-hidden="true"><div class="pk-bar__in">' +
      '<span class="pk-bar__text"><span class="pk-bar__count">' + esc(fill(txt.items || '{count} items', { count: t.count })) +
        (t.save > 0 ? ' · ' + esc(txt.save || 'You save') + ' ' + money(t.save, fmt) : '') + '</span>' +
      '<span class="pk-bar__price">' + money(t.pay, fmt) + '</span></span>' +
      '<button type="button" class="pk-cta pk-cta--bar" data-act="add"' + (this.busy ? ' disabled' : '') + '>' + esc(this.busy ? (txt.adding || 'Adding to cart') : (txt.button_short || 'Add to cart')) + '</button>' +
      '</div></div>';
  };

  Builder.prototype.renderLayer = function () {
    if (!this.layer) return;
    var t = this.totals(), html = this.barHTML(t);
    if (this.sheet) html += this.sheetHTML();
    if (this.specs) html += this.specsHTML();
    if (this.zoom) {
      html += '<div class="pk-zoom' + (this.zoomBig ? ' is-big' : '') + '" role="dialog" aria-modal="true" aria-label="' + esc(this.txt.zoom || 'Zoomed photo') + '">' +
        '<button type="button" class="pk-x pk-zoom__x" data-act="close" aria-label="' + esc(this.txt.close || 'Close') + '"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg></button>' +
        '<div class="pk-zoom__scroll" data-act="zoomflip"><img src="' + esc(this.zoom) + '" alt=""></div>' +
        '<p class="pk-zoom__hint">' + esc(this.txt.zoom_hint || 'Tap to zoom in or out') + '</p></div>';
    }
    /* keep the panel's scroll position when it re-renders (a price changed) */
    var keep = this.layer.querySelector('.pk-sheet__body'), top = keep ? keep.scrollTop : 0;
    var keepPop = this.layer.querySelector('.pk-pop__body'), topPop = keepPop ? keepPop.scrollTop : 0;
    this.layer.innerHTML = html;
    var b2 = this.layer.querySelector('.pk-sheet__body');
    if (b2 && top) b2.scrollTop = top;
    var p2 = this.layer.querySelector('.pk-pop__body');
    if (p2 && topPop) p2.scrollTop = topPop;
    this.lock();
    this.syncBar();
  };

  /* ------------------------------------------------------------ list */
  Builder.prototype.thumb = function (it, size) {
    var src = imgUrl(it._img, size * 2);
    return '<span class="pk-thumb" style="width:' + size + 'px;height:' + size + 'px"><img src="' + esc(src) + '" alt="" loading="lazy" width="' + size + '" height="' + size + '"></span>';
  };

  Builder.prototype.diffTag = function (diff) {
    var fmt = this.moneyFormat, txt = this.txt;
    if (diff === 0) return esc(txt.same || 'Same price');
    return (diff > 0 ? '+ ' : '− ') + money(Math.abs(diff), fmt);
  };

  Builder.prototype.chipsHTML = function (slot, opt, vsel, xkey) {
    if (!opt.pick) return '';
    var self = this, curDims = (opt.items[vsel] || {})._dims || {};
    var prefix = xkey ? 'xpick-' + xkey : 'pick-' + slot.id;
    return '<div class="pk-pick">' + this.dims(opt).map(function (d) {
      return '<div class="pk-pick__dim" role="group" aria-label="' + esc(d.name) + '"><span class="pk-pick__label">' + esc(d.name) + '</span><span class="pk-pick__chips">' +
        d.values.map(function (v) {
          var on = v === curDims[d.name];
          return '<button type="button" class="pk-chip' + (on ? ' is-on' : '') + '" data-act="pick" data-slot="' + esc(slot.id) + '"' + (xkey ? ' data-key-x="' + esc(xkey) + '"' : '') +
            ' data-dim="' + esc(d.name) + '" data-val="' + esc(v) + '" data-key="' + esc(prefix + '-' + d.name + '-' + v) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + esc(v) + '</button>';
        }).join('') + '</span></div>';
    }).join('') + '</div>';
  };

  Builder.prototype.qtyHTML = function (q, act, attr, label, key, canDown) {
    var txt = this.txt;
    return '<div class="pk-qty" role="group" aria-label="' + esc((txt.quantity || 'Quantity') + ', ' + label) + '">' +
      '<button type="button" class="pk-qty__b" data-act="' + act + '" ' + attr + ' data-d="-1" data-key="' + esc(key.replace('{d}', 'down')) + '"' + (q > 1 && canDown ? '' : ' disabled') + ' aria-label="' + esc(txt.fewer || 'One fewer') + '">&minus;</button>' +
      '<span class="pk-qty__n" aria-live="polite">' + q + '</span>' +
      '<button type="button" class="pk-qty__b" data-act="' + act + '" ' + attr + ' data-d="1" data-key="' + esc(key.replace('{d}', 'up')) + '"' + (q < MAXQ ? '' : ' disabled') + ' aria-label="' + esc(txt.more_one || 'One more') + '">+</button>' +
      '</div>';
  };

  /* one line of the list: the package's own line for a slot, or an added line */
  Builder.prototype.lineHTML = function (o, t) {
    var self = this, fmt = this.moneyFormat, txt = this.txt;
    var slot = o.slot, opt = o.opt, its = o.items, q = o.q;
    var pay = 0, rrp = 0;
    its.forEach(function (it) { pay += self.linePrice(it, t.mode, t.own) * q; rrp += it._rrp * q; });
    var first = its[0];
    var specsAttr = function (it) { return ' data-act="specs" data-h="' + esc(it.handle) + '" data-v="' + esc(it._v.id) + '" data-slot-label="' + esc(slot.label) + '"'; };
    var names = its.map(function (it, i) {
      return '<li' + (i ? ' class="pk-sub"' : '') + '><button type="button" class="pk-name"' + specsAttr(it) + '>' + esc(opt.pick ? opt.label : it._title) + '</button></li>';
    }).join('');
    var media = its.length > 1
      ? '<button type="button" class="pk-row__media pk-row__media--many"' + specsAttr(first) + ' aria-label="' + esc((txt.see_specs || 'See specs') + ', ' + first._title) + '">' + its.slice(0, 4).map(function (it) { return self.thumb(it, 27); }).join('') + '</button>'
      : '<button type="button" class="pk-row__media"' + specsAttr(first) + ' aria-label="' + esc((txt.see_specs || 'See specs') + ', ' + first._title) + '">' + this.thumb(first, 56) + '</button>';
    var canDown = this.count(this.items()) - 1 >= (this.floor || 0);
    var acts = [];
    if (o.extra) {
      var xk = o.extra.key;
      if (slot.options.filter(function (x) { return x._ok; }).length > 1) acts.push('<button type="button" class="pk-act" data-act="xchange" data-slot="' + esc(slot.id) + '" data-key-x="' + esc(xk) + '" data-key="xchange-' + esc(xk) + '">' + esc(txt.change || 'Change') + '</button>');
      var canX = this.count(this.items()) - o.extra.q >= (this.floor || 0);
      acts.push('<button type="button" class="pk-act pk-act--quiet" data-act="xremove" data-key-x="' + esc(xk) + '" data-key="xremove-' + esc(xk) + '"' + (canX ? '' : ' aria-disabled="true"') + '>' + esc(txt.remove || 'Remove') + '</button>');
    } else {
      if (this.choices(slot).length > 1) acts.push('<button type="button" class="pk-act" data-act="tray" data-slot="' + esc(slot.id) + '" data-key="tray-' + esc(slot.id) + '">' +
        esc(txt.change || 'Change') + '<span class="pk-sr"> ' + esc(slot.label) + '</span></button>');
      if (this.canAddAnother(slot)) acts.push('<button type="button" class="pk-act" data-act="another" data-slot="' + esc(slot.id) + '" data-key="another-' + esc(slot.id) + '">' +
        esc(txt.add_another || 'Add another') + '<span class="pk-sr"> ' + esc(slot.label) + '</span></button>');
      if (slot.removable) {
        var can = this.canRemove(slot);
        acts.push('<button type="button" class="pk-act pk-act--quiet" data-act="remove" data-slot="' + esc(slot.id) + '" data-key="remove-' + esc(slot.id) + '"' +
          (can ? '' : ' aria-disabled="true" title="' + esc(fill(txt.floor_title || 'The package needs at least {min} items', { min: this.floor })) + '"') + '>' +
          esc(txt.remove || 'Remove') + '<span class="pk-sr"> ' + esc(slot.label) + '</span></button>');
      }
    }
    var note = (!o.extra && this.adjusted[slot.id]) ? '<p class="pk-row__flag">' + esc(txt.adjusted || 'Changed to suit your other choices.') + '</p>' : '';
    var qty = o.extra
      ? this.qtyHTML(q, 'xqty', 'data-key-x="' + esc(o.extra.key) + '"', slot.label, 'xqty-{d}-' + o.extra.key, canDown)
      : this.qtyHTML(q, 'qty', 'data-slot="' + esc(slot.id) + '"', slot.label, 'qty-{d}-' + slot.id, canDown);
    return '<article class="pk-row' + (o.extra ? ' pk-row--added' : '') + '" data-row="' + esc(o.extra ? o.extra.key : slot.id) + '">' +
      media +
      '<div class="pk-row__body"><p class="pk-row__slot">' + esc(o.extra ? fill(txt.extra_label || '{slot}, extra', { slot: slot.label }) : slot.label) + '</p>' +
        '<ul class="pk-row__names">' + names + '</ul>' +
        '<button type="button" class="pk-specs"' + specsAttr(first) + '>' + esc(txt.see_specs || 'See specs') + '</button>' +
        this.chipsHTML(slot, opt, o.extra ? o.extra.vsel : opt.vsel, o.extra ? o.extra.key : null) + note +
        (acts.length ? '<div class="pk-row__acts">' + acts.join('<span class="pk-dot" aria-hidden="true">·</span>') + '</div>' : '') +
      '</div>' +
      '<div class="pk-row__price"><span class="pk-price">' + money(pay, fmt) + '</span>' + (rrp > pay ? '<s class="pk-was">' + money(rrp, fmt) + '</s>' : '') + qty + '</div>' +
      '</article>';
  };

  Builder.prototype.doubleHTML = function (d) {
    var txt = this.txt, names = d.add.map(function (s) { return String(s.label).toLowerCase(); });
    var list = names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
    return '<div class="pk-prompt" role="note"><p class="pk-prompt__text"><strong>' + esc(txt.double_title || 'Double-bowl vanity') + '</strong> ' +
      esc(fill(txt.double_text || 'Two basins usually need a second {list}. Add them?', { list: list })) + '</p>' +
      '<div class="pk-prompt__acts"><button type="button" class="pk-add" data-act="double" data-yes="1" data-key="double-yes">' + esc(txt.double_yes || 'Add the second set') + '</button>' +
      '<button type="button" class="pk-act pk-act--quiet" data-act="double" data-yes="0" data-key="double-no">' + esc(txt.double_no || 'No thanks') + '</button></div></div>';
  };

  /* a removed or optional item */
  Builder.prototype.extraHTML = function (slot, t) {
    var txt = this.txt;
    var back = this.backOption(slot);
    if (!back) return '';
    var wasDefault = slot.default != null;
    var diff = this.totals(this.preview(slot.id, back.id)).pay - t.pay;
    var it = this.optItems(back)[0];
    return '<article class="pk-row pk-row--extra' + (wasDefault ? ' is-removed' : '') + '" data-row="' + esc(slot.id) + '">' +
      '<button type="button" class="pk-row__media" data-act="specs" data-h="' + esc(it.handle) + '" data-v="' + esc(it._v.id) + '" data-slot-label="' + esc(slot.label) + '" aria-label="' + esc((txt.see_specs || 'See specs') + ', ' + it._title) + '">' + this.thumb(it, 48) + '</button>' +
      '<div class="pk-row__body"><p class="pk-row__slot">' + esc(slot.label) + '</p><p class="pk-row__name">' + esc(back.label || slot.label) + '</p>' +
        '<p class="pk-row__off">' + esc(wasDefault ? (txt.removed || 'Removed') : (txt.optional || 'Optional')) + ' · ' + this.diffTag(diff) + '</p></div>' +
      '<div class="pk-row__price"><button type="button" class="pk-add" data-act="restore" data-slot="' + esc(slot.id) + '" data-key="restore-' + esc(slot.id) + '">' +
        esc(wasDefault ? (txt.add_back || 'Add back') : (txt.add || 'Add')) + '<span class="pk-sr"> ' + esc(back.label || slot.label) + '</span></button></div>' +
      '</article>';
  };

  /* Other finishes and sizes of this package (from the section's "family" lists) */
  Builder.prototype.familyHTML = function () {
    var fam = this.cfg.family, txt = this.txt || {}, fmt = this.moneyFormat;
    if (!fam) return '';
    var html = '';
    if (fam.colours && fam.colours.length > 1) {
      html += '<div class="pk-fam__row pk-fam--colours"><span class="pk-fam__label">' + esc(txt.finish || 'Finish') + '</span><div class="pk-fam__tiles">' +
        fam.colours.map(function (p) {
          var inner = '<span class="pk-fam__img">' + (p.image ? '<img src="' + esc(imgUrl(p.image, 240)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="pk-fam__name">' + esc(p.label) + '</span>';
          return p.current
            ? '<span class="pk-fam__tile is-current" aria-current="page">' + inner + '</span>'
            : '<a class="pk-fam__tile" href="' + esc(p.url) + '">' + inner + '</a>';
        }).join('') + '</div></div>';
    }
    if (fam.sizes && fam.sizes.length > 1) {
      html += '<div class="pk-fam__row pk-fam--sizes"><span class="pk-fam__label">' + esc(txt.size || 'Size') + '</span><div class="pk-fam__chips">' +
        fam.sizes.map(function (p) {
          var inner = '<span class="pk-fam__name">' + esc(p.label) + '</span>' + (p.price ? '<span class="pk-fam__price">' + money(p.price, fmt) + '</span>' : '');
          return p.current
            ? '<span class="pk-fam__chip is-current" aria-current="page">' + inner + '</span>'
            : '<a class="pk-fam__chip" href="' + esc(p.url) + '">' + inner + '</a>';
        }).join('') + '</div></div>';
    }
    return html ? '<nav class="pk-fam" aria-label="' + esc(txt.family || 'Other versions of this package') + '">' + html + '</nav>' : '';
  };

  Builder.prototype.totalHTML = function (t) {
    var fmt = this.moneyFormat, txt = this.txt, rule = this.rule();
    var html = '<div class="pk-total" aria-live="polite">' +
      '<div class="pk-total__line"><span>' + esc(fill(t.count === 1 ? (txt.item || '1 item') : (txt.items || '{count} items'), { count: t.count })) + '</span>' +
      '<span class="pk-total__pay">' + (t.rrp > t.pay ? '<s>' + money(t.rrp, fmt) + '</s> ' : '') + '<strong>' + money(t.pay, fmt) + '</strong></span></div>';
    if (t.save > 0) {
      var pct = t.rrp ? Math.round((t.save / t.rrp) * 100) : 0;
      html += '<p class="pk-total__save">' + esc(txt.save || 'You save') + ' ' + money(t.save, fmt) + ' (' + pct + '%)</p>';
    }
    if (this.floor && t.count <= this.floor) {
      html += '<p class="pk-total__hint">' + esc(fill(txt.floor || '{min} items is the minimum for the package price. Swap an item, or add one before removing another.', { min: this.floor })) + '</p>';
    } else if (rule.live && rule.min && t.short > 0) {
      html += '<p class="pk-total__warn">' + esc(fill(txt.short || 'Add {n} more to get the package price.', { n: t.short, min: rule.min })) + '</p>';
    }
    if (!t.base) html += '<button type="button" class="pk-link" data-act="reset" data-key="reset">' + esc(txt.reset || 'Back to the original package') + '</button>';
    html += '</div>';
    return html;
  };

  Builder.prototype.render = function () {
    if (!this.view) return;
    var self = this, t = this.totals(), txt = this.txt;
    var active = this.root.activeElement || null;
    var key = this.focusKey || (active && active.getAttribute ? active.getAttribute('data-key') : null);
    this.focusKey = null;

    /* the list in package order: each slot's own line, then the lines added to it */
    var entries = [];
    this.cfg.slots.forEach(function (s) {
      var id = self.sel[s.id];
      if (id != null) {
        var opt = self.option(s, id);
        entries.push({ slot: s, opt: opt, items: self.optItems(opt), q: self.qty[s.id] || 1 });
      }
      self.extras.forEach(function (e) {
        if (e.slot !== s.id) return;
        var o2 = self.option(s, e.opt);
        if (o2 && o2._ok) entries.push({ slot: s, opt: o2, items: self.optItems(o2, e.vsel), q: e.q, extra: e });
      });
    });
    var outSlots = this.cfg.slots.filter(function (s) { return self.sel[s.id] == null && self.backOption(s); });
    var limit = this.collapseAfter;
    var collapsible = limit > 0 && entries.length > limit + 1;
    var showAll = !collapsible || this.expanded;
    var shown = showAll ? entries : entries.slice(0, limit);
    var dbl = this.doubleBowl();
    var gap = this.showerGap(), gapAt = -1;
    if (gap) shown.forEach(function (en, i) { if (en.slot === gap.shower) gapAt = i; });

    var head = '<div class="pk-head"><h3 class="pk-head__title">' + esc(txt.title || "What's included") + '</h3>' +
      '<span class="pk-head__count">' + esc(fill(txt.items || '{count} items', { count: t.count })) + '</span></div>';
    var rows = '<div class="pk-list">' + shown.map(function (en, i) {
      var h = self.lineHTML(en, t);
      if (dbl && !en.extra && en.slot === dbl.slot) h += self.doubleHTML(dbl);
      if (gap && i === gapAt) h += self.gapHTML(gap);
      return h;
    }).join('') + '</div>';
    var more = '';
    if (collapsible) {
      var label = showAll ? (txt.less || 'Show fewer') : fill(txt.more || 'Show all {count} items', { count: t.count });
      more = '<button type="button" class="pk-more" data-act="more" data-key="more" aria-expanded="' + (showAll ? 'true' : 'false') + '">' + esc(label) + '</button>';
    }
    var extras = '';
    if (outSlots.length) {
      extras = '<div class="pk-extras"><p class="pk-extras__title">' + esc(txt.extras || 'Add to your package') + '</p>' +
        outSlots.map(function (s) { return self.extraHTML(s, t); }).join('') + '</div>';
    }
    var own = this.mode === 'section'
      ? '<button type="button" class="pk-cta" data-act="add" data-key="cta"' + (this.busy ? ' disabled' : '') + '>' + esc(this.busy ? (txt.adding || 'Adding to cart') : (txt.button || 'Add package to cart')) + '</button>'
      : '';
    var msgs = (this.error ? '<p class="pk-error" role="alert">' + esc(this.error) + '</p>' : '') +
      (this.done ? '<p class="pk-ok" role="status">' + esc(txt.added || 'Added to your cart.') + '</p>' : '');

    this.view.innerHTML = this.familyHTML() + head + rows + more + extras + this.totalHTML(t) + msgs + own;

    if (key) {
      var again = this.view.querySelector('[data-key="' + key + '"]');
      if (again && again.focus) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
    }
    if (this.io && this.mode === 'section') {
      var cta = this.view.querySelector('.pk-cta');
      if (this.ctaEl && this.ctaEl !== cta) this.io.unobserve(this.ctaEl);
      if (cta) { this.io.observe(cta); this.ctaEl = cta; }
    }
    this.renderLayer();
    this.syncForm();
    this.syncPrice(t);
  };

  /* ------------------------------------------------------------ boot */
  function boot() {
    var hosts = document.querySelectorAll('[data-bbpkg]:not([data-bbpkg-started])');
    Array.prototype.forEach.call(hosts, function (host) {
      host.setAttribute('data-bbpkg-started', '');
      var b = new Builder(host);
      BBPKG.instances.push(b);
      try {
        var p = b.start();
        if (p && p.catch) p.catch(function (e) { b.fail((e && e.message) || 'error'); });
      } catch (e) { b.fail((e && e.message) || 'error'); }
    });
  }
  BBPKG.boot = boot;
  BBPKG.Builder = Builder;
  BBPKG.money = money;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
